<template>
  <div id="app">
    <div class="AppStage">
        <router-view/>
    </div>
    <div class="FFSFooter" style="clear: both;">
      <div>Build 1.4</div>
      <div>Designed by Jacksonville Area Legal Aid and built by SavvySuit with &#x2764; in Florida</div>
    </div>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/index.css'

export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0px;
}

body {
  margin: 0px;
}

#app div.FFSFooter {
  font-size: 0.8em;
  margin-top: 20px;
  margin-bottom: 20px;
}

#app div.AppStage {
  clear: both;
}
</style>
